import React from 'react';
import { useLogin } from '../hooks/useLogin';

const LoginArrowUp = () => {
	const { forgotPassword } = useLogin();
	return (
		<a href="/" className="vtex-login-2-x-forgotPasswordLink forgotPasswordLink link dim c-link t-small">
			{forgotPassword}
		</a>
	);
};

export default LoginArrowUp;
